import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, renderList as _renderList, Fragment as _Fragment, withCtx as _withCtx, createVNode as _createVNode, createTextVNode as _createTextVNode } from "vue"
import _imports_0 from '@/assets/img/icon/info-outline-blue.svg'
import _imports_1 from '@/assets/img/icon/bus-outline-blue-default.svg'
import _imports_2 from '@/assets/img/icon/snack-outline-blue.svg'
import _imports_3 from '@/assets/img/modal-confirmation/snack-empty.svg'
import _imports_4 from '@/assets/img/icon/money-outlined-blue.svg'


const _hoisted_1 = {
  key: 0,
  class: "roster-snack-form"
}
const _hoisted_2 = {
  class: "xl:flex gap-3",
  style: {"height":"auto","min-height":"45vh"}
}
const _hoisted_3 = { class: "w-full xl:w-3/4 mb-2 xl:mb-0" }
const _hoisted_4 = {
  key: 0,
  class: "mb-4 px-3 py-2 border-primary flex items-center background-blue-4 rounded-lg gap-3"
}
const _hoisted_5 = /*#__PURE__*/_createElementVNode("img", {
  src: _imports_0,
  alt: "img"
}, null, -1)
const _hoisted_6 = /*#__PURE__*/_createElementVNode("div", { class: "text-sm text-primary" }, "PP sudah diberangkatkan, Anda tidak bisa mengatur snack untuk perjalanan ini", -1)
const _hoisted_7 = [
  _hoisted_5,
  _hoisted_6
]
const _hoisted_8 = /*#__PURE__*/_createElementVNode("div", { class: "flex items-center gap-3 mb-2" }, [
  /*#__PURE__*/_createElementVNode("img", {
    src: _imports_1,
    alt: "bus",
    style: {"width":"32px"}
  }),
  /*#__PURE__*/_createElementVNode("div", { class: "text-2xl font-bold" }, "Informasi Keberangkatan")
], -1)
const _hoisted_9 = { class: "mb-4 pb-4 border-bottom-grey-3" }
const _hoisted_10 = { class: "md:flex items-center gap-1 mb-1" }
const _hoisted_11 = /*#__PURE__*/_createElementVNode("div", { class: "w-1/5 text-grey text-sm" }, "Nopol", -1)
const _hoisted_12 = { class: "w-4/5 text-sm" }
const _hoisted_13 = { class: "md:flex items-center gap-1 mb-1" }
const _hoisted_14 = /*#__PURE__*/_createElementVNode("div", { class: "w-1/5 text-grey text-sm" }, "Nama Trayek", -1)
const _hoisted_15 = { class: "w-4/5 text-sm" }
const _hoisted_16 = { class: "md:flex items-center gap-1 mb-1" }
const _hoisted_17 = /*#__PURE__*/_createElementVNode("div", { class: "w-1/5 text-grey text-sm" }, "Nama PP / Jam", -1)
const _hoisted_18 = { class: "w-4/5 text-sm" }
const _hoisted_19 = { class: "md:flex gap-30px mb-5" }
const _hoisted_20 = { class: "w-full md:w-1/4" }
const _hoisted_21 = /*#__PURE__*/_createElementVNode("div", { class: "text-lg font-semibold" }, "Gudang Asal", -1)
const _hoisted_22 = {
  key: 0,
  class: "text-sm text-grey"
}
const _hoisted_23 = { class: "md:flex gap-30px overflow-y-scroll" }
const _hoisted_24 = /*#__PURE__*/_createElementVNode("div", { class: "w-full md:w-1/4" }, [
  /*#__PURE__*/_createElementVNode("div", { class: "text-lg font-semibold" }, "Snack yang Dibawa"),
  /*#__PURE__*/_createElementVNode("div", { class: "text-sm text-grey" }, "Daftar Snack yang Dibawa Kondektur")
], -1)
const _hoisted_25 = {
  class: "flex-1 w-full md:w-3/4",
  style: {"height":"auto","min-height":"44vh"}
}
const _hoisted_26 = { class: "flex items-center gap-4" }
const _hoisted_27 = ["src"]
const _hoisted_28 = { class: "text-base font-bold" }
const _hoisted_29 = { class: "text-sm" }
const _hoisted_30 = { class: "text-base font-bold" }
const _hoisted_31 = { class: "w-full xl:w-1/4" }
const _hoisted_32 = { class: "flex flex-col h-full" }
const _hoisted_33 = /*#__PURE__*/_createElementVNode("div", { class: "flex items-center gap-3 mb-4" }, [
  /*#__PURE__*/_createElementVNode("img", {
    src: _imports_2,
    alt: "snack",
    style: {"width":"32px"}
  }),
  /*#__PURE__*/_createElementVNode("div", { class: "text-2xl font-bold" }, "Review")
], -1)
const _hoisted_34 = /*#__PURE__*/_createElementVNode("div", { class: "mb-2 pb-2 border-bottom-grey-3" }, [
  /*#__PURE__*/_createElementVNode("div", { class: "text-sm" }, "Total snack yang dibawa kondektur")
], -1)
const _hoisted_35 = { key: 0 }
const _hoisted_36 = /*#__PURE__*/_createElementVNode("img", {
  src: _imports_3,
  alt: "img",
  class: "my-3 mx-auto"
}, null, -1)
const _hoisted_37 = /*#__PURE__*/_createElementVNode("div", { class: "text-xs text-center" }, "Oops, kamu belum mengatur snack yang akan dibawa Kondektur!", -1)
const _hoisted_38 = [
  _hoisted_36,
  _hoisted_37
]
const _hoisted_39 = { key: 1 }
const _hoisted_40 = { class: "flex items-center justify-between mb-4" }
const _hoisted_41 = /*#__PURE__*/_createElementVNode("div", { class: "flex items-center gap-3" }, [
  /*#__PURE__*/_createElementVNode("img", {
    src: _imports_2,
    alt: "snack",
    style: {"width":"16px"}
  }),
  /*#__PURE__*/_createElementVNode("div", { class: "text-sm text-grey font-semibold" }, "Total Snack")
], -1)
const _hoisted_42 = { class: "text-sm font-semibold text-right" }
const _hoisted_43 = { class: "flex items-center justify-between" }
const _hoisted_44 = /*#__PURE__*/_createElementVNode("div", { class: "flex items-center gap-3" }, [
  /*#__PURE__*/_createElementVNode("img", {
    src: _imports_4,
    alt: "money",
    style: {"width":"16px"}
  }),
  /*#__PURE__*/_createElementVNode("div", { class: "text-sm text-grey font-semibold" }, "Total Harga Snack")
], -1)
const _hoisted_45 = { class: "text-sm font-semibold text-right" }
const _hoisted_46 = { class: "flex items-center justify-end mt-4" }
const _hoisted_47 = /*#__PURE__*/_createTextVNode("Kembali")

import { encryptDecriptMethods } from '@/plugins/encryptDecriptMethods'
import { onMounted, ref, getCurrentInstance, watch, computed } from 'vue'
import { useRoute, useRouter } from 'vue-router'
import { useStore } from 'vuex'
import Card from 'primevue/card'
import rupiahFormat from '@/utils/helpers/rupiahFormat'
import numberFormat from '@/utils/helpers/numberFormat'
import * as Yup from 'yup'
import Button from 'primevue/button'
import apiOpenUseCase from '@/usecase/apiOpenUseCase'
import moment from 'moment'
import environment from '@/configs/environtment'
import changeImagePathPrefix from '@/utils/helpers/changeImagePathPrefix'
import defaulListImage from '@/assets/img/icon/cross-black-background-grey.svg'


export default /*#__PURE__*/_defineComponent({
  __name: 'RosterSnackSummary',
  setup(__props) {

const endpoint = '/ticket/v1/Snacks'
const store = useStore()
const route = useRoute()
const router = useRouter()
const app = getCurrentInstance()
const {
  $toast
} = app!.appContext.config.globalProperties
const dataHeader = ref(null) as any
const snackList = ref([]) as any
// const totalPrice = ref(0)
// const totalQty = ref(0)
const dataForm = ref()
const isRoster = ref(false)
const isLoading = ref(true)
const isShowFormList = ref(false)
const rosterSnackData = ref()
const rosterSnackList = ref([]) as any
const snackListByBuilding = ref([]) as any

const toPrevPage = () => {
  router.push({
    name: 'roster'
  })
}

const setBuildingData = async () => {
  store.dispatch('showLoading')
  // await Promise.all([
  //   store.dispatch('userProfiles/fetchUserEmploymentAndBuilding')
  // ])
  const building = await store.dispatch('userProfiles/fetchUserEmploymentAndBuilding')
  console.log('building', store.state.userProfiles.building)
  isLoading.value = false
  store.dispatch('hideLoading')
}

const checkAssignedSnack = () => {
  store.dispatch('showLoading')
  apiOpenUseCase.get(`${endpoint}/Transfer/ByReference/${dataHeader.value.Id}`).then((response) => {
    console.log('snackList', response.result)
    const { result, error } = response
    if (!error) {
      rosterSnackData.value = result
      rosterSnackList.value = result.SnackTransferItems.map((data: any) => ({
        ...data,
        Image: data.SnackImage ? `${environment.getApiImageBaseUrl()}${changeImagePathPrefix(data.SnackImage)}` : defaulListImage,
      }))
    }
  })
  store.dispatch('hideLoading')
}

onMounted(async () => {
  console.log('xxx', store.state?.userProfile?.resource_access['hjp-microservices'].roles.includes('Roster'))
  isRoster.value = store.state?.userProfile?.resource_access['hjp-microservices'].roles.includes('Roster')
  if (isRoster.value) {
    await setBuildingData()
  } else {
    isLoading.value = false
  }
  dataHeader.value = encryptDecriptMethods.decrypt(route.params.id)
  console.log('header', dataHeader.value)
  checkAssignedSnack()
  store.dispatch('ui/setBreadcrumbs', [
    {
      title: 'Roster',
      routeName: 'roster'
    },
    {
      title: `PP${dataHeader.value.PpOrder} (${moment(dataHeader.value.RosterDate).format('HH:mm')})`,
      routeName: 'roster'
    },
    {
      title: 'Atur Snack',
      routeName: 'roster-snack-detail',
      params: { id: route.params.id }
    }
  ])
})

return (_ctx: any,_cache: any) => {
  return (!isLoading.value)
    ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
        _createVNode(_unref(Card), { class: "card-no-shadow wrap-hjp-data-table roster-main" }, {
          content: _withCtx(() => [
            _createElementVNode("div", _hoisted_2, [
              _createElementVNode("div", _hoisted_3, [
                _createVNode(_unref(Card), { class: "card-no-shadow wrap-hjp-data-table" }, {
                  content: _withCtx(() => [
                    (_unref(dataHeader)?.IsAlreadyDeparture)
                      ? (_openBlock(), _createElementBlock("div", _hoisted_4, _hoisted_7))
                      : _createCommentVNode("", true),
                    _hoisted_8,
                    _createElementVNode("div", _hoisted_9, [
                      _createElementVNode("div", _hoisted_10, [
                        _hoisted_11,
                        _createElementVNode("div", _hoisted_12, _toDisplayString(_unref(dataHeader)?.RegNumber), 1)
                      ]),
                      _createElementVNode("div", _hoisted_13, [
                        _hoisted_14,
                        _createElementVNode("div", _hoisted_15, _toDisplayString(`Trayek ${_unref(dataHeader)?.TrayekClassName} | ${_unref(dataHeader)?.IsTol ? 'Tol' : 'Non Tol'} | ${_unref(dataHeader)?.TrayekName}`), 1)
                      ]),
                      _createElementVNode("div", _hoisted_16, [
                        _hoisted_17,
                        _createElementVNode("div", _hoisted_18, _toDisplayString(`PP${_unref(dataHeader)?.PpOrder} / ${_unref(moment)(_unref(dataHeader)?.RosterDate).format('HH:mm')}`), 1)
                      ])
                    ]),
                    _createElementVNode("div", _hoisted_19, [
                      _createElementVNode("div", _hoisted_20, [
                        _hoisted_21,
                        (!isRoster.value)
                          ? (_openBlock(), _createElementBlock("div", _hoisted_22, "Gudang pengambilan snack"))
                          : _createCommentVNode("", true)
                      ]),
                      _createElementVNode("div", null, _toDisplayString(rosterSnackData.value?.ToBuildingName ?? '-'), 1)
                    ]),
                    _createElementVNode("div", _hoisted_23, [
                      _hoisted_24,
                      _createElementVNode("div", _hoisted_25, [
                        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(rosterSnackList), (data) => {
                          return (_openBlock(), _createElementBlock("div", {
                            key: data.SnackId,
                            class: "flex items-center justify-between border-grey-3 rounded-xl px-4 py-2 mb-2"
                          }, [
                            _createElementVNode("div", _hoisted_26, [
                              _createElementVNode("img", {
                                src: data.Image,
                                class: "rounded-lg",
                                alt: "snackImg",
                                style: {"width":"60px"}
                              }, null, 8, _hoisted_27),
                              _createElementVNode("div", null, [
                                _createElementVNode("div", _hoisted_28, _toDisplayString(data.SnackName ?? '-'), 1),
                                _createElementVNode("div", _hoisted_29, _toDisplayString(`${_unref(rupiahFormat)(data.SnackFinalPrice ?? 0)} / Pack`), 1)
                              ])
                            ]),
                            _createElementVNode("div", _hoisted_30, _toDisplayString(_unref(numberFormat)(data.Quantity ?? 0)) + " Pack", 1)
                          ]))
                        }), 128))
                      ])
                    ])
                  ]),
                  _: 1
                })
              ]),
              _createElementVNode("div", _hoisted_31, [
                _createVNode(_unref(Card), { class: "card-no-shadow wrap-hjp-data-table" }, {
                  content: _withCtx(() => [
                    _createElementVNode("div", _hoisted_32, [
                      _hoisted_33,
                      _hoisted_34,
                      (_unref(rosterSnackList).length === 0)
                        ? (_openBlock(), _createElementBlock("div", _hoisted_35, _hoisted_38))
                        : (_openBlock(), _createElementBlock("div", _hoisted_39, [
                            _createElementVNode("div", _hoisted_40, [
                              _hoisted_41,
                              _createElementVNode("div", _hoisted_42, _toDisplayString(_unref(numberFormat)(rosterSnackData.value?.SnackItemCount ?? 0)) + " Pack", 1)
                            ]),
                            _createElementVNode("div", _hoisted_43, [
                              _hoisted_44,
                              _createElementVNode("div", _hoisted_45, _toDisplayString(_unref(rupiahFormat)(rosterSnackData.value?.SnackItemAmount ?? 0)) + " Pack", 1)
                            ])
                          ]))
                    ])
                  ]),
                  _: 1
                })
              ])
            ]),
            _createElementVNode("div", _hoisted_46, [
              _createVNode(_unref(Button), {
                class: "btn-back mr-2",
                onClick: _cache[0] || (_cache[0] = ($event: any) => (toPrevPage()))
              }, {
                default: _withCtx(() => [
                  _hoisted_47
                ]),
                _: 1
              })
            ])
          ]),
          _: 1
        })
      ]))
    : _createCommentVNode("", true)
}
}

})